export default {
  setCustomers: (state, customers) => (state.customers = customers),
  setCustomersCount: (state, customersCount) =>
    (state.customersCount = customersCount),
  setLoading: (state, loading) => (state.loading = loading),
};
